<template>
	<div class="sablonok">
    <v-app id="tablazat">
      <v-simple-table>
        <template v-slot:default>
          <thead>
            <th class="text-center">Sablon neve</th>
            <th class="text-center">Sablon kezelése</th>
            <!--<th class="text-center">Csoport nyomtatása</th>-->
          </thead>
          <tbody>
            <tr v-for="sablon in sablonok" v-bind:key="sablon.id">
              <td class="text-center"> {{sablon.nev}} </td>
              <td class="text-center">
								<router-link :to="{ name: 'csoportgyakorlatok', params: {id: sablon.id} }"><v-btn color="orange">Gyakorlatok</v-btn></router-link>
							</td>

              <!--<td class="text-center"> nyomtatás {{csoport.id}} </td>-->
            </tr>
            <tr>
              <td colspan="3">
                <v-form ref="sablonhozzaadasa"
                        lazy-validation
                >
                  <v-text-field
                    v-model="ujsablonnev"
                    label="Sablon neve"
                    required
                  ></v-text-field>
                  <v-btn
                    color="success"
                    @click="ujsablon"
                  >
                    Létrehozás
                  </v-btn>
                </v-form>
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </v-app>
	</div>

</template>

<script>
/*import axios from 'axios'
axios.defaults.withCredentials = true*/
     import router from "../router"

export default {

  data: function () {
  	return {
  		sablonok: [],
      ujsablonnev: ''
  	}
  },
  methods: {
  	sablonokfrissitese: function () {
      var ideiglenessablon = []
  		this.axios
  			.get(this.$store.state.backendeleres+'csoportok/sablonok')
  			.then(response => {this.sablonok = response.data;
          if(response.data.bejelentkezve==false){
                    this.$store.commit('bejelentkezve', false)
                    router.push('/bejelentkezes');
                    this.$store.commit('admin',false)
            }
          })
  	},
    ujsablon: function () {
      this.axios
        .post(this.$store.state.backendeleres+'csoportok', { nev: this.ujsablonnev, sablon: true })
        .then(response => {
          if (response.data.ok) {
            this.sablonok.push({ id: response.data.id, nev: response.data.nev })
          }
          if(response.data.bejelentkezve==false){
                  this.$store.commit('bejelentkezve', false)
                  router.push('/bejelentkezes');
                  this.$store.commit('admin',false)
          }
        })
      this.ujsablonnev = ''
    }
  },
  mounted () {
    this.sablonokfrissitese()
  }
}
</script>
